// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmUmFmZkK_xEiAWl1_0PlJTkICyl6I8lI",
  authDomain: "ieeedkte.firebaseapp.com",
  projectId: "ieeedkte",
  storageBucket: "ieeedkte.appspot.com",
  messagingSenderId: "273482727999",
  appId: "1:273482727999:web:73bf4de38fb8873cb26e8a",
  measurementId: "G-RY87PP0Y87"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;